import { TableView } from 'prosemirror-tables'

// 열 크기 조절용 기본 TableView는 table의 기존 HTML 속성을 표시하지 않는다.
// 모델의 스타일/클래스/caption을 실제 편집 화면에도 반영하는 어댑터를 둔다.
export class CompatibleTableView extends TableView {
  constructor (node, minimumWidth) {
    super(node, minimumWidth)
    this.syncAttributes(node)
  }

  update (node) {
    if (!super.update(node)) return false
    this.syncAttributes(node)
    return true
  }

  syncAttributes (node) {
    const attrs = node.attrs.htmlAttrs
    Array.from(this.table.attributes).forEach(attribute => this.table.removeAttribute(attribute.name))
    Object.keys(attrs).forEach(name => this.table.setAttribute(name, attrs[name]))
    const hasWidths = node.firstChild && Array.from({ length: node.firstChild.childCount }, (_, index) => node.firstChild.child(index)).some(cell => cell.attrs.colwidth)
    if (hasWidths) {
      // 이미 조절한 열 너비는 엔진이 설정한 픽셀 너비로 다시 계산한다.
      super.update(node)
    } else if (node.attrs.columns) {
      const old = document.createElement('table')
      old.innerHTML = node.attrs.columns
      Array.from(old.querySelectorAll('col')).forEach((col, index) => {
        if (this.colgroup.children[index]) this.colgroup.children[index].style.cssText = col.style.cssText
      })
    }
    const oldCaption = this.table.querySelector('caption')
    if (oldCaption) this.table.removeChild(oldCaption)
    if (node.attrs.caption) {
      const holder = document.createElement('table')
      holder.innerHTML = node.attrs.caption
      const caption = holder.querySelector('caption')
      if (caption) {
        caption.contentEditable = 'false'
        this.table.insertBefore(caption, this.table.firstChild)
      }
    }
  }

  ignoreMutation (record) {
    return !this.contentDOM.contains(record.target) || super.ignoreMutation(record)
  }
}



// WEBPACK FOOTER //
// ./src/components/ETC/editor/tableView.js